<template>
  <div class="loginBox">
    <div class="main_center">
      <div class="loginForm">
        <div class="loginTiltle fs28 ftc22 ftb">招标管理系统</div>
        <!-- <div class="loginTiltle fs28 ftc22 ftb">重庆交运集团废旧物资处置平台</div> -->
        <div class="isLogin">
          <div
            class="loginText"
            :class="current == 1 ? 'active' : ''"
            @click="changeLogin(1)"
          >
            登录
          </div>
          <div
            class="regText"
            :class="current == 2 ? 'active' : ''"
            @click="changeLogin(2)"
          >
            注册
          </div>
        </div>
        <div class="formBox" v-if="current == 1">
          <el-form :model="loginForm" :rules="rules" ref="loginForm">
            <el-form-item prop="accountNumberAndPhone">
              <el-input
                v-model="loginForm.accountNumberAndPhone"
                placeholder="请输入账号/手机号"
                style="width: 340px"
              ></el-input>
            </el-form-item>
            <el-form-item prop="pwd">
              <el-input
                v-model="loginForm.pwd"
                placeholder="请输入密码"
                style="width: 340px"
                type="password"
                show-password
              ></el-input>
            </el-form-item>
            <el-form-item class="elFormImg" prop="verification">
              <el-input
                v-model="loginForm.verification"
                placeholder="输入验证码"
                style="width: 200px"
              ></el-input>
              <img :src="baseImg" alt="" class="imgBlock" @click="updateCode" />
            </el-form-item>
            <el-form-item class="btnBox">
              <el-button class="" @click="gohomepage">登录</el-button>
            </el-form-item>
          </el-form>
          <div class="agreement">
            <!-- <div class="checkBox">
              <el-checkbox-group
                v-model="checkedCities"
                text-color="#14D393"
                fill="#14D393"
              >
                <el-checkbox>我已阅读并同意《用户协议》</el-checkbox>
              </el-checkbox-group>
            </div> -->
            <div class="ftc14D fs14">我已阅读并同意《用户协议》</div>
            <div
              class="ftc14D fs14"
              style="padding: 0 20px"
              @click="forgetPwdfn"
            >
              忘记密码？
            </div>
          </div>
        </div>
        <div class="formBox" v-if="current == 2">
          <el-form :model="regForm" ref="regForm" :rules="regRules">
            <el-form-item prop="account">
              <el-input
                v-model="regForm.account"
                placeholder="请输入用户名"
                style="width: 340px"
              ></el-input>
            </el-form-item>
            <el-form-item prop="mobilePhone">
              <el-input
                v-model="regForm.mobilePhone"
                placeholder="请输入手机号"
                style="width: 340px"
              ></el-input>
            </el-form-item>
            <!--  <el-form-item class="elFormImg">
              <el-input
                v-model="regForm.type"
                placeholder="输入图形验证码"
                style="width: 200px"
              ></el-input>
              <img :src="baseImg" alt="" class="imgBlock" />
            </el-form-item> -->
            <el-form-item class="phoneCode" prop="verificationCode">
              <el-input
                v-model="regForm.verificationCode"
                placeholder="输入手机验证码"
                style="width: 200px"
              ></el-input>
              <el-button
                @click="sendVerificationCodeapi"
                :disabled="!isdisable"
                :class="isdisable ? 'btncode' : 'activeBtn'"
                >{{
                  isdisable ? "获取验证码" : `${seconds}后重新获取`
                }}</el-button
              >
            </el-form-item>
            <el-form-item class="btnBox">
              <el-button class="" @click="goReg">下一步</el-button>
            </el-form-item>
          </el-form>
        </div>
      </div>
      <div class="right_img"></div>
    </div>
    <!-- 验证码弹框 -->
    <bounced :dialogVisible.sync="dialogVisible" title="请输入图形验证码">
      <div slot="slotInfo" class="slotInfo">
        <div class="elFormCode">
          <img :src="imgCode" alt="" class="imgCode" />
        </div>
        <div>
          <el-form :model="codeForm" ref="codeForm">
            <el-form-item
              prop="code"
              :rules="{
                required: true,
                validator: (rule, value, callback) =>
                  regular.FormValidateIsTrue(
                    rule,
                    value,
                    callback,
                    regular.verificationCode(value),
                    '请输入长度为4位的验证码'
                  )
              }"
            >
              <el-input
                v-model="codeForm.code"
                placeholder="请输入验证码"
              ></el-input>
            </el-form-item>
          </el-form>
        </div>
        <div class="btns">
          <el-button class="cancel" @click="cancelfn">取消</el-button>
          <el-button class="sureBtn" @click="submitcode">确定</el-button>
        </div>
      </div>
    </bounced>
    <!-- 登录验证框 -->
    <bounced
      :dialogVisible.sync="isaudit"
      :title="title[errCode].name"
      :width="title[errCode].width"
    >
      <div slot="slotInfo" class="isaudit">
        <div class="fs14 ftc66 errorInfo">{{ title[errCode].text }}</div>
        <div class="auditBox">
          <el-button
            type="small"
            class="auditCancel"
            v-if="errCode == 2"
            @click="cancelfn"
            >取消</el-button
          >
          <el-button type="small" class="auditBtn" @click="changeisaudit">{{
            errCode == 2 ? "重新提交" : "确定"
          }}</el-button>
        </div>
      </div>
    </bounced>
    <!-- 忘记密码弹框 -->
    <bounced
      :dialogVisible.sync="forgetpwd"
      :title="forgetTitle[step].title"
      :showClose="true"
      width="500px"
      @handleClose="handleClose"
    >
      <div slot="slotInfo">
        <!-- 第一步 -->
        <div class="forgetPwd" v-if="step == 0">
          <el-form
            size="small"
            label-width="100px"
            :model="ForgetPasswordLogin"
            :rules="forgetRules"
            ref="ForgetPasswordLogin"
          >
            <el-form-item label="账号" prop="accountOrMobilePhone">
              <el-input
                placeholder="请输入用户名/手机号"
                style="width: 300px"
                v-model="ForgetPasswordLogin.accountOrMobilePhone"
              ></el-input>
            </el-form-item>
            <el-form-item
              label="验证码"
              class="forgetCode"
              prop="verificationCode"
            >
              <el-input
                placeholder="请输入验证码"
                style="width: 200px"
                v-model="ForgetPasswordLogin.verificationCode"
              ></el-input>
              <div style="padding: 0 10px">
                <img
                  :src="forgetImg"
                  alt=""
                  style="width: 90px; height: 32px"
                />
              </div>
            </el-form-item>
          </el-form>
          <div class="btns">
            <el-button class="sureBtn" @click.stop="submitForget"
              >下一步</el-button
            >
          </div>
        </div>
        <!-- 第二步 -->
        <div class="forgetPwd" v-if="step == 1">
          <el-form
            size="small"
            label-width="100px"
            :model="ForgetPasswordLoginStep2"
            :rules="forgetRules"
            ref="ForgetPasswordLoginStep2"
          >
            <el-form-item label="账号">
              <span>{{
                this.ForgetPasswordLogin.accountOrMobilePhone || "-"
              }}</span>
            </el-form-item>
            <el-form-item
              label="验证码"
              class="forgetCode"
              prop="verificationCode"
            >
              <el-input
                placeholder="请输入验证码"
                style="width: 200px"
                v-model="ForgetPasswordLoginStep2.verificationCode"
              ></el-input>
              <div style="padding: 0 10px">
                <el-button
                  class="sureBtn"
                  @click.stop="getForgetPasswordVerificationapi"
                  :disabled="!isReg"
                  :class="isReg ? 'sureBtn' : 'regBtn'"
                  >{{
                    isReg ? "获取验证码" : `${regSeconds}后重新获取`
                  }}</el-button
                >
              </div>
            </el-form-item>
          </el-form>
          <div class="btns">
            <el-button class="sureBtn" @click.stop="changeStep"
              >下一步</el-button
            >
          </div>
        </div>
        <!-- 第三步 -->
        <div class="forgetPwd" v-if="step == 2">
          <div
            class="fs12 ftc14D"
            style="padding-bottom: 20px; text-align: center"
          >
            您正在找回的账号是：{{
              this.ForgetPasswordLogin.accountOrMobilePhone || "-"
            }}
          </div>
          <el-form
            size="small"
            label-width="100px"
            :model="ForgetPasswordLoginstep3"
            :rules="updatePwd"
            ref="ForgetPasswordLoginstep3"
          >
            <el-form-item label="新密码" prop="newPwd">
              <el-input
                placeholder="请输入"
                style="width: 300px"
                v-model="ForgetPasswordLoginstep3.newPwd"
                type="password"
                show-password
              ></el-input>
            </el-form-item>
            <el-form-item label="确认密码" class="forgetCode" prop="confirmPwd">
              <el-input
                placeholder="请输入"
                style="width: 300px"
                v-model="ForgetPasswordLoginstep3.confirmPwd"
                type="password"
                show-password
              ></el-input>
            </el-form-item>
          </el-form>
          <div class="btns">
            <el-button class="sureBtn" @click.stop="updateSubmit"
              >确定</el-button
            >
          </div>
        </div>
      </div>
    </bounced>
  </div>
</template>

<script>
import {
  login,
  getCode,
  getForgetPasswordLogin,
  getForgetPasswordVerification,
  getForgetPasswordVerificationCode,
  verifyAccount,
  sendVerifyCode,
  passwordVerification,
  updatePasswordByForget
} from "@/api/login/index";
import {
  register,
  sendVerificationCode,
  verificationRegister
} from "@/api/reg/index";
import { v4 as uuidv4 } from "uuid";
import regular from "@/util/regular";
import bounced from "@/components/bounced.vue";
// import {Base64} from 'js-base64'
import md5 from "js-md5";
export default {
  components: {
    bounced
  },
  data() {
    var validatePhone = (rule, value, callback) =>
      regular.FormValidateIsTrue(
        rule,
        value,
        callback,
        regular.testPhone(value),
        "手机号未填写或格式错误"
      );
    var validateVerificationCode = (rule, value, callback) =>
      regular.FormValidateIsTrue(
        rule,
        value,
        callback,
        regular.verificationCode(value),
        "验证码未填写或格式错误"
      );
    var validatetestUserName = (rule, value, callback) =>
      regular.FormValidateIsTrue(
        rule,
        value,
        callback,
        regular.testUserName(value),
        "用户名包含字母和数字，且字母开头"
      );
    var validateVerification = (rule, value, callback) =>
      regular.FormValidateIsTrue(
        rule,
        value,
        callback,
        regular.verificationCode(value),
        "验证码未填写或格式错误"
      );
    var validateNewPwd = (rule, value, callback) =>
      regular.FormValidateIsTrue(
        rule,
        value,
        callback,
        regular.validatePwd(value),
        "密码包含 数字,英文,字符中的两种以上，长度8-14"
      );
    var validateConfirmPwd = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("密码不能为空"));
      } else {
        if (value !== this.ForgetPasswordLoginstep3.newPwd) {
          callback(new Error("两次密码不一致"));
        } else {
          let t1 = /^(?![0-9]+$)(?![a-z]+$)(?![A-Z]+$)(?!([^(0-9a-zA-Z)])+$).{8,14}$/;
          if (t1.test(value)) {
            callback();
          } else {
            callback(
              new Error("密码包含 数字,英文,字符中的两种以上，长度8-14")
            );
          }
        }
      }
    };
    return {
      loginForm: {
        accountNumberAndPhone: "", //账户或者手机号
        pwd: "", //用户密码,
        uuid: "",
        verification: "" //图形验证码
      },
      regForm: {
        account: "",
        mobilePhone: "",
        verificationCode: ""
      },
      ForgetPasswordLogin: {
        accountOrMobilePhone: "", //账户或者手机号
        UUID: "",
        verificationCode: "" //图形验证码
      },
      ForgetPasswordLoginStep2: {
        verificationCode: "" //图形验证码
      },
      ForgetPasswordLoginstep3: {
        confirmPwd: "",
        newPwd: "",
        sysUserId: ""
      },
      checkedCities: false,
      baseImg: "",
      imgCode: "",
      regular,
      codeForm: {
        code: ""
      },
      rules: {
        accountNumberAndPhone: [
          {
            required: true,
            message: "请输入账户或手机号",
            trigger: "blur"
          }
        ],
        pwd: [
          {
            required: true,
            message: "请输入密码",
            trigger: "blur"
          }
        ],
        verification: [
          {
            required: true,
            message: "请输入验证码",
            trigger: "blur"
          },
          {
            required: true,
            validator: validateVerification,
            trigger: "blur"
          }
        ]
      },
      current: 1,
      dialogVisible: false,
      isdisable: true,
      seconds: 60,
      UUid: "",
      isaudit: false,
      errCode: 0, //1成功，-22审核未通过 -21 审核中 -16用户权限不足
      regRules: {
        account: [
          {
            required: true,
            validator: validatetestUserName,
            trigger: "blur"
          }
        ],
        mobilePhone: [
          {
            required: true,
            validator: validatePhone,
            trigger: "blur"
          }
        ],
        verificationCode: [
          {
            required: true,
            validator: validateVerificationCode,
            trigger: "blur"
          }
        ]
      },
      forgetRules: {
        verificationCode: [
          {
            required: true,
            validator: validateVerificationCode,
            trigger: "blur"
          }
        ],
        accountOrMobilePhone: [
          {
            required: true,
            message: "请输入账户或手机号",
            trigger: "blur"
          }
        ]
      },
      updatePwd: {
        confirmPwd: [
          {
            required: true,
            validator: validateConfirmPwd,
            trigger: "blur"
          }
        ],
        newPwd: {
          required: true,
          validator: validateNewPwd,
          trigger: "blur"
        }
      },
      title: [
        {
          name: "暂无权限",
          text: "您的账号还没有登录处置平台权限，请联系相关业务人员开通",
          width: "490px"
        },
        {
          name: "审核中",
          text: "您的注册信息还在审核中，请耐心等候！",
          width: "390px"
        },
        {
          name: "审核未通过",
          text: "资料信息不完整，请重新提交。",
          width: "390px"
        }
      ],
      modifyArr: [],
      forgetpwd: false,
      forgetImg: "",
      forgetTitle: [
        {
          title: "忘记密码"
        },
        {
          title: "安全验证"
        },
        {
          title: "重置密码"
        }
      ],
      step: 0,
      regObj: {},
      isReg: true,
      regSeconds: 60
    };
  },
  created() {
    // 全局添加回车事件
    document.onkeydown = e => {
      var key = window.event.keyCode;
      if (key === 13) {
        this.gohomepage();
      }
    };
  },
  mounted() {
    this.getCodeapi();
    if (this.$route.query.current) {
      this.current = this.$.query.current;
    }
  },
  methods: {
    getcodefn(uuid) {
      return new Promise((resolve, reject) => {
        getCode({
          uuid
        }).then(res => {
          resolve(res.data.data);
        });
      });
    },
    /* 获取验证码 */
    getCodeapi() {
      this.loginForm.uuid = uuidv4();
      let uuid = this.loginForm.uuid;
      this.getcodefn(uuid).then(res => {
        this.baseImg = res;
      });
    },
    gohomepage() {
      this.$refs.loginForm.validate(v => {
        if (v) {
          // if (this.checkedCities) {
          let data = {
            ...this.loginForm,
            pwd: md5(this.loginForm.pwd) //密码加密
          };
          login(data).then(res => {
            if (res.data.code == 1) {
              this.$router.push({
                path: "/home/homepage"
              });
              this.isaudit = false;
              sessionStorage.setItem("sessionId", res.data.data.sessionId);
              sessionStorage.setItem(
                "backstageUser",
                JSON.stringify(res.data.data.backstageUser)
              );
            } else {
              localStorage.setItem("modifyArr", JSON.stringify(res.data.data));
              this.through(res.data);
            }
          });
          // } else {
          //   this.$message.error("请勾选同意用户协议");
          // }
        }
      });
    },
    /* 是否登录通过 */
    through(data) {
      /* //1成功，-22审核未通过 -21 审核中 -16用户权限不足 */
      if (data.code == -22) {
        this.errCode = 2;
        this.isaudit = true;
      } else if (data.code == -21) {
        this.errCode = 1;
        this.isaudit = true;
      } else if (data.code == -16) {
        this.errCode = 0;
        this.isaudit = true;
      } else {
        this.$message.error(data.msg);
        this.getCodeapi();
      }
    },
    changeLogin(val) {
      this.current = val;
      if (val == 2) {
        this.$refs.loginForm.resetFields();
      } else {
        this.$refs.regForm.resetFields();
      }
    },
    goReg() {
      this.$refs.regForm.validate(volid => {
        if (volid) {
          verificationRegister(this.regForm).then(res => {
            console.log(this.regForm);
            if (res.data.code == 1) {
              this.$router.push({
                path: "/reg",
                query: {
                  str: JSON.stringify(this.regForm)
                }
              });
            }
          });
        }
      });
    },
    /* 刷新验证码 */
    updateCode() {
      this.getCodeapi();
    },
    /* 发送手机验证码 */
    sendVerificationCodeapi() {
      this.$refs.regForm.validateField("mobilePhone", volid => {
        if (volid == "") {
          this.dialogVisible = true;
          let uuid = uuidv4();
          this.UUid = uuid;
          this.getcodefn(uuid).then(res => {
            this.imgCode = res;
          });
        }
      });
    },
    cancelfn() {
      this.$refs.codeForm.resetFields();
      this.dialogVisible = false;
    },
    /* 倒计时 */
    countdownfn() {
      let id = setInterval(res => {
        if (this.seconds >= 1) {
          this.seconds--;
        } else {
          this.isdisable = true;
          clearInterval(id);
        }
      }, 1000);
    },
    submitcode() {
      this.$refs.codeForm.validate(volid => {
        if (volid) {
          sendVerificationCode({
            mobilePhone: this.regForm.mobilePhone,
            verification: this.codeForm.code,
            UUid: this.UUid
          }).then(res => {
            if (res.data.code == 1) {
              this.$message({
                type: "success",
                message: res.data.data
              });
              this.dialogVisible = false;
              this.codeForm.code = "";
              this.isdisable = false;
              this.seconds = 60;
              this.countdownfn();
            }
          });
        }
      });
    },
    changeisaudit() {
      if (this.errCode != 2) {
        this.isaudit = false;
      } else {
        this.$router.push({
          path: "/reg",
          query: {
            id: 1
          }
        });
      }
    },
    /* 忘记密码 */
    forgetPwdfn() {
      this.forgetpwd = true;
      this.ForgetPasswordLogin.UUID = uuidv4();
      let uuid = this.ForgetPasswordLogin.UUID;
      getForgetPasswordVerificationCode({
        uuid
      }).then(res => {
        this.forgetImg = res.data.data;
      });
    },
    submitForget() {
      this.$refs.ForgetPasswordLogin.validate(volid => {
        if (volid) {
          verifyAccount(this.ForgetPasswordLogin).then(res => {
            if (res.data.code == 1) {
              this.step = 1;
              this.regObj = res.data.data;
            }
          });
        }
      });
    },
    getForgetPasswordVerificationapi() {
      sendVerifyCode({
        mobilePhone: this.regObj.mobilePhone
      }).then(res => {
        if (res.data.code == 1) {
          this.isReg = false;
          this.regSeconds = 60;
          let id = setInterval(res => {
            if (this.regSeconds >= 1) {
              this.regSeconds--;
            } else {
              this.isReg = true;
              clearInterval(id);
            }
          }, 1000);
        }
      });
    },
    changeStep() {
      this.$refs.ForgetPasswordLoginStep2.validate(async volid => {
        if (volid) {
          let obj = {
            sysUserMobilePhone: this.regObj.mobilePhone,
            verificationCode: this.ForgetPasswordLoginStep2.verificationCode
          };
          let { data } = await passwordVerification(obj);
          if (data.code == 1) {
            this.step = 2;
          }
        }
      });
    },
    updateSubmit() {
      this.$refs.ForgetPasswordLoginstep3.validate(async volid => {
        if (volid) {
          this.ForgetPasswordLoginstep3.sysUserId = this.regObj.sysUserId;
          let { data } = await updatePasswordByForget(
            this.ForgetPasswordLoginstep3
          );
          if (data.code == 1) {
            this.$message({
              type: "success",
              message: "修改成功"
            });
            /* 关闭弹框 */
            this.forgetpwd = false;
            /* 清空 */
            this.isReg = true;
            this.ForgetPasswordLoginStep2.verificationCode = "";
            this.ForgetPasswordLoginstep3.confirmPwd = "";
            this.ForgetPasswordLoginstep3.newPwd = "";
            this.handleClose();
          }
        }
      });
    },
    handleClose() {
      this.step = 0;
      this.ForgetPasswordLogin.UUID = "";
      this.ForgetPasswordLogin.verificationCode = "";
      // this.$set(this.ForgetPasswordLogin, "verificationCode", "");
      this.ForgetPasswordLogin.accountOrMobilePhone = "";
    }
  }
};
</script>

<style lang="less" scoped>
.active {
  color: #14d393;
}

.active::before {
  content: "";
  position: absolute;
  bottom: -8px;
  padding: 1px 22px;
  background: #14d393;
  left: 4px;
}

.loginBox {
  background: url("../../image/bg1.png") no-repeat;
  height: 100%;
  min-width: 1200px;
  background-size: cover;
  background-position: center;
  display: flex;
  align-items: center;
  justify-content: center;
  .main_center {
    position: relative;
    background: url("../../image/bg_center.png") no-repeat;
    background-size: 100% 100%;
    width: 1190px;
    height: 600px;
  }
  .loginForm {
    position: absolute;
    top: 100px;
    left: 100px;

    .isLogin {
      display: flex;
      justify-content: space-around;
      padding: 30px 0;

      .loginText,
      .regText {
        position: relative;
        padding: 0 10px;
        cursor: pointer;
      }
    }

    .formBox {
      width: 360px;
      margin: 0 auto;

      .el-form-item {
        margin-bottom: 30px;
      }
    }
  }

  .right_img {
    position: absolute;
    right: 100px;
    bottom: 100px;
    width: 400px;
    height: 200px;
    background-image: url("../../image/login_right.png");
    background-size: 100% 100%;
  }
}

.elFormImg {
  /deep/.el-form-item__content {
    display: flex;

    .imgBlock {
      display: block;
      width: 130px;
      height: 40px;
      margin-left: 10px;
      cursor: pointer;
    }
  }
}

.elFormCode {
  .imgCode {
    display: block;
    width: 130px;
    height: 40px;
    margin: 0 auto 20px;
  }
}

.btnBox {
  margin-top: 70px;
  margin-bottom: 10px !important;

  /deep/.el-button {
    background-color: #14d393 !important;
    color: #fff !important;
    width: 340px;
    border: 1px solid #14d393;
  }
}

.phoneCode {
  /deep/.el-button {
    color: #fff !important;

    width: 130px;
    margin-left: 7px;
  }
}

.btncode {
  background-color: #14d393 !important;
  border: 1px solid #14d393;
}

.activeBtn {
  border: none !important;
  background-color: #e5e5e5 !important;
}

.regBtn {
  border: none !important;
  background-color: #e5e5e5 !important;
  width: 100px !important;
}

.agreement {
  display: flex;
  justify-content: space-between;
}

// .checkBox::after {
//   content: "请勾选";
//   color: red;
//   font-size: 12px;
// }
// .el-checkbox__input.is-checked .el-checkbox__inner {
//   color: #14d393 !important;
//   background: #14d393 !important;
// }
// .el-checkbox__input.is-checked + .el-checkbox__label {
//   color: #14d393 !important;
// }
.sureBtn {
  width: 90px;
  height: 32px;
  background: #15d393;
  border: none;
  color: #fff;
  font-size: 12px;
}

.cancel {
  width: 90px;
  height: 37px;
}

.btns {
  text-align: center;
}

.errorInfo {
  text-align: center;
}

.auditBox {
  text-align: center;
  padding-top: 30px;
}

.auditCancel {
  width: 90px;
  height: 32px;
}

.auditBtn {
  width: 90px;
  height: 32px;
  background: #15d393;
  border-radius: 5px;
  color: #fff;
  border: none;
}

.forgetCode {
  /deep/.el-form-item__content {
    margin-left: 0 !important;
    display: flex;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/login/login.vue